// extracted by mini-css-extract-plugin
export default {"subLinkContainer":"styles_subLinkContainer__iYeCD","isHover":"styles_isHover__Zv8bG","isSelected":"styles_isSelected__AzsiC","subLinkText":"styles_subLinkText__vYZRb"};